module.exports = __webpack_public_path__ + "img/level2addon_mining_hands_mask.16f99717.png";